module.exports = __webpack_public_path__ + "static/media/removeFavBrokenHeartIcon.44a5cc0d.svg";